/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Franchises_FreeInputs */

const id_franchises_free = /** @type {(inputs: Franchises_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis`)
};

const ms_franchises_free = /** @type {(inputs: Franchises_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Percuma`)
};

const da_franchises_free = /** @type {(inputs: Franchises_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis`)
};

const de_franchises_free = /** @type {(inputs: Franchises_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenlos`)
};

const en_us2_franchises_free = /** @type {(inputs: Franchises_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free`)
};

const es_es2_franchises_free = /** @type {(inputs: Franchises_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis`)
};

const es_mx2_franchises_free = /** @type {(inputs: Franchises_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis`)
};

const fil_franchises_free = /** @type {(inputs: Franchises_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Libre`)
};

const fr_franchises_free = /** @type {(inputs: Franchises_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratuit`)
};

const it_franchises_free = /** @type {(inputs: Franchises_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis`)
};

const hu_franchises_free = /** @type {(inputs: Franchises_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingyenes`)
};

const nl_franchises_free = /** @type {(inputs: Franchises_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis`)
};

const no_franchises_free = /** @type {(inputs: Franchises_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis`)
};

const pl_franchises_free = /** @type {(inputs: Franchises_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Darmowe`)
};

const pt_br2_franchises_free = /** @type {(inputs: Franchises_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grátis`)
};

const pt_franchises_free = /** @type {(inputs: Franchises_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grátis`)
};

const ro_franchises_free = /** @type {(inputs: Franchises_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratuit`)
};

const fi_franchises_free = /** @type {(inputs: Franchises_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilmainen`)
};

const sv_franchises_free = /** @type {(inputs: Franchises_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis`)
};

const vi_franchises_free = /** @type {(inputs: Franchises_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miễn phí`)
};

const tr_franchises_free = /** @type {(inputs: Franchises_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ücretsiz`)
};

const cs_franchises_free = /** @type {(inputs: Franchises_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zdarma`)
};

const bg_franchises_free = /** @type {(inputs: Franchises_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Безплатно`)
};

const ru_franchises_free = /** @type {(inputs: Franchises_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Бесплатно`)
};

const uk_franchises_free = /** @type {(inputs: Franchises_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Безкоштовно`)
};

const ar_franchises_free = /** @type {(inputs: Franchises_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مجاني`)
};

const hi_franchises_free = /** @type {(inputs: Franchises_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मुफ़्त`)
};

const th_franchises_free = /** @type {(inputs: Franchises_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ฟรี`)
};

const ja_franchises_free = /** @type {(inputs: Franchises_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料`)
};

const zh_cn2_franchises_free = /** @type {(inputs: Franchises_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费`)
};

const zh_hant1_franchises_free = /** @type {(inputs: Franchises_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免費`)
};

const ko_franchises_free = /** @type {(inputs: Franchises_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`무료`)
};

/**
* | output |
* | --- |
* | "Free" |
*
* @param {Franchises_FreeInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const franchises_free = /** @type {((inputs?: Franchises_FreeInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Franchises_FreeInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_franchises_free(inputs)
	if (locale === "ms") return ms_franchises_free(inputs)
	if (locale === "da") return da_franchises_free(inputs)
	if (locale === "de") return de_franchises_free(inputs)
	if (locale === "en-US") return en_us2_franchises_free(inputs)
	if (locale === "es-ES") return es_es2_franchises_free(inputs)
	if (locale === "es-MX") return es_mx2_franchises_free(inputs)
	if (locale === "fil") return fil_franchises_free(inputs)
	if (locale === "fr") return fr_franchises_free(inputs)
	if (locale === "it") return it_franchises_free(inputs)
	if (locale === "hu") return hu_franchises_free(inputs)
	if (locale === "nl") return nl_franchises_free(inputs)
	if (locale === "no") return no_franchises_free(inputs)
	if (locale === "pl") return pl_franchises_free(inputs)
	if (locale === "pt-BR") return pt_br2_franchises_free(inputs)
	if (locale === "pt") return pt_franchises_free(inputs)
	if (locale === "ro") return ro_franchises_free(inputs)
	if (locale === "fi") return fi_franchises_free(inputs)
	if (locale === "sv") return sv_franchises_free(inputs)
	if (locale === "vi") return vi_franchises_free(inputs)
	if (locale === "tr") return tr_franchises_free(inputs)
	if (locale === "cs") return cs_franchises_free(inputs)
	if (locale === "bg") return bg_franchises_free(inputs)
	if (locale === "ru") return ru_franchises_free(inputs)
	if (locale === "uk") return uk_franchises_free(inputs)
	if (locale === "ar") return ar_franchises_free(inputs)
	if (locale === "hi") return hi_franchises_free(inputs)
	if (locale === "th") return th_franchises_free(inputs)
	if (locale === "ja") return ja_franchises_free(inputs)
	if (locale === "zh-CN") return zh_cn2_franchises_free(inputs)
	if (locale === "zh-Hant") return zh_hant1_franchises_free(inputs)
	return ko_franchises_free(inputs)
});
export { franchises_free as "franchises.free" }